<!-- Main Dashboard Container -->
<div class="row" *ngIf="userType==7 || userType==5 || userType==1">
  <div class="col-xl-12">
    <app-card cardTitle="Dashboard Overview" [options]="false" blockClass="table-border-style">

      <!-- Admin Dashboard (userType == 1) -->
      <div class="row">
        <!-- Total Members Exist -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor' [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Members Exist</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-users f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalMembersExist ?? ((dashboardData?.totalHome ?? dashboardData?.homeCount ?? 0) + (dashboardData?.totalHospital ?? dashboardData?.hospitalCount ?? 0) + (dashboardData?.totalTemporary ?? dashboardData?.tempCount ?? 0))}}
            </h3>
          </app-card>
        </div>

        <!-- Home Count -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor' [hidHeader]="true" [routerLink]="['/members']" [queryParams]="{type: 'Home'}">
            <h6 class="mb-2">Total Home</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-home f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalHome ?? dashboardData?.homeCount}}
            </h3>
          </app-card>
        </div>

        <!-- Hospital Count -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']" [queryParams]="{type: 'Hospital'}">
            <h6 class="mb-2">Total Hospital</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalHospital ?? dashboardData?.hospitalCount}}
            </h3>
          </app-card>
        </div>

        <!-- Temporary Count -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']" [queryParams]="{type: 'Temporary'}">
            <h6 class="mb-2">Total Temporary</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-clock f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalTemporary ?? dashboardData?.tempCount}}
            </h3>
          </app-card>
        </div>

        <!-- Total Categories -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/categories')">
            <h6 class="mb-2">Total Categories</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-layers f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalCategories}}
            </h3>
          </app-card>
        </div>

        <!-- Total Wards -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/wards')">
            <h6 class="mb-2">Total Wards</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-grid f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWards}}
            </h3>
          </app-card>
        </div>

        <!-- Total Ward Incharge -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/users')">
            <h6 class="mb-2">Total Ward Incharge</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-user-check f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWardIncharge}}
            </h3>
          </app-card>
        </div>

        <!-- Total Discharged -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']" [queryParams]="{isShowDischage: true}">
            <h6 class="mb-2">Total Discharged</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-log-out f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalDischarge}}
            </h3>
          </app-card>
        </div>

      </div>

      <!-- Category Wise Table -->
      <div class="row mt-4">
        <div class="col-md-6">
          <h5 class="mb-4">Category Wise</h5>
          <app-card class='cursor'  cardTitle="Category Wise Count" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Category</th>
                    <th> Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let item of dashboardData?.categoriesWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPersons}}</td>
                    <td>

                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span  class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>

        <!-- Ward Wise Count -->
        <div class="col-md-6">
          <h5 class="mb-4">Ward Wise</h5>
          <app-card cardTitle="Ward Wise Count" cardClass="table-card" blockClass="p-0" style="height:300px; overflow-y: auto;">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Ward</th>
                    <th>Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of dashboardData?.wardWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPersons}}</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

      <!-- Ward Category Wise -->
      <div class="row mt-4" *ngIf="dashboardData?.wardCategoryWise && dashboardData?.wardCategoryWise?.length > 0">
        <div class="col-md-12">
          <app-card cardTitle="Ward Category Breakdown" [options]="false" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Ward</th>
                    <th>Category</th>
                    <th>Persons</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let ward of dashboardData?.wardCategoryWise">
                    <tr *ngFor="let cat of ward.categories; let isFirst = first">
                      <td *ngIf="isFirst" [attr.rowspan]="ward.categories.length">
                        {{ ward.wardName || 'Unassigned' }}
                      </td>
                      <td>{{ cat.categoryName }}</td>
                      <td>{{ cat.totalPersons }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

      <!-- Recent People -->
      <div class="row mt-4">
        <div class="col-md-12">
          <h5 class="mb-4">Recent Added People</h5>
          <app-card cardTitle="Recent People" cardClass="table-card" blockClass="p-0" class='cursor' >
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>Gender</th>
                    <th>Ward</th>
                    <th>Category</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let p of dashboardData?.recentPeople; let i=index" [routerLink]="['/member/view', p?._id]"  class='cursor'>
                    <td>{{i+1}}</td>

                    <td>{{p?.name}}</td>

                    <td>#{{p?.regNo}}</td>

                    <td>
                      {{ p?.gender === 1 ? 'Male' : p?.gender === 2 ? 'Female' : 'Other' }}
                    </td>

                    <td>{{p?.wardId?.name || 'NA'}}</td>

                    <td>{{p?.categoryId?.name}}</td>

                    <td>{{p?.createdAt | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

       
      <!-- Discharge Wise Count -->
      <div class="row mt-4">
        <div class="col-md-6">
          <h5 class="mb-4">Discharge Wise</h5>
          <app-card class='cursor'  cardTitle="Discharge Wise Count" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Discharge Type</th>
                    <th>Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let item of dashboardData?.dischargeWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPerson}}</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span  class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>

        <div class="col-md-6">
          <h5 class="mb-4">Recent Discharged People</h5>
          <app-card cardTitle="Recent Discharged People" cardClass="table-card" blockClass="p-0" class='cursor' >
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>Discharge Time</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let p of dashboardData?.dischargePeople; let i=index" [routerLink]="['/members']"  class='cursor'>
                    <td>{{i+1}}</td>
                    <td>{{p?.name}}</td>
                    <td>#{{p?.regNo}}</td>
                    <td>{{p?.closeTime | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

       <!-- if end -->

    </app-card>
  </div>
</div>


<!-- HOSPITAL ADMIN PLUS DOCTORS -->
 <div class="row" *ngIf="userType==8 || userType==10">
  <div class="col-xl-12">
    <app-card cardTitle="Dashboard Overview" [options]="false" blockClass="table-border-style">

      <!-- Admin Dashboard (userType == 1) -->
      <div class="row">
        <!-- Home Count -->
        

        <!-- Hospital Count -->
        <div class="col-md-6 col-xl-4" *ngIf="false">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Hospital</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.hospitalCount}}
            </h3>
          </app-card>
        </div>

        <!-- Total Categories -->
        <div class="col-md-6 col-xl-4" *ngIf="false">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/categories')">
            <h6 class="mb-2">Total Categories</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-layers f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalCategories}}
            </h3>
          </app-card>
        </div>

        <!-- Total Wards -->
        <div class="col-md-6 col-xl-4" *ngIf="false">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/wards')">
            <h6 class="mb-2">Total Wards</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-grid f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWards}}
            </h3>
          </app-card>
        </div>

        <!-- Total Ward Incharge -->
        <div class="col-md-6 col-xl-4" *ngIf="false">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/users')">
            <h6 class="mb-2">Total Ward Incharge</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-user-check f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWardIncharge}}
            </h3>
          </app-card>
        </div>

        <!-- Total Discharged -->
        <div class="col-md-6 col-xl-4" >
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']" [queryParams]="{isShowDischage: true}">
            <h6 class="mb-2">Total Discharged</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-log-out f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalDischarge}}
            </h3>
          </app-card>
        </div>

        <h3>Lab Test</h3>
        <hr>

        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Pending Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.pending}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Completed Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.completed}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Rejected Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.rejected}}
            </h3>
          </app-card>
        </div>



        <!-- Hospital Count -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Pending Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.total?.pending}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Completed Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.total?.completed}}
            </h3>
          </app-card>
        </div>
        
      </div>


       <!-- Category Wise Table -->
      <div class="row mt-4">
        <!-- Ward Wise Count -->
        <div class="col-md-12">
          <h5 class="mb-4">Ward Wise (Present)</h5>
          <app-card cardTitle="Ward Wise Count" cardClass="table-card" blockClass="p-0" style="height:300px; overflow-y: auto;">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Ward</th>
                    <th>Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of dashboardData?.wardWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPersons}}</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>


     
      <!-- Ward Category Wise -->
      <div class="row mt-4" *ngIf="dashboardData?.wardCategoryWise && dashboardData?.wardCategoryWise?.length > 0">
        <div class="col-md-12">
          <app-card cardTitle="Ward Category Breakdown" [options]="false" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Ward</th>
                    <th>Category</th>
                    <th>Persons</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let ward of dashboardData?.wardCategoryWise">
                    <tr *ngFor="let cat of ward.categories; let isFirst = first">
                      <td *ngIf="isFirst" [attr.rowspan]="ward.categories.length">
                        {{ ward.wardName || 'Unassigned' }}
                      </td>
                      <td>{{ cat.categoryName }}</td>
                      <td>{{ cat.totalPersons }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

      <!-- Recent People -->
      <div class="row mt-4">
        <div class="col-md-12">
          <h5 class="mb-4">Recent Added People</h5>
          <app-card cardTitle="Recent People" cardClass="table-card" blockClass="p-0" class='cursor' >
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>Gender</th>
                    <th>Ward</th>
                    <th>Category</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let p of dashboardData?.recentPeople; let i=index" [routerLink]="['/member/view', p?._id]"  class='cursor'>
                    <td>{{i+1}}</td>

                    <td>{{p?.name}}</td>

                    <td>#{{p?.regNo}}</td>

                    <td>
                      {{ p?.gender === 1 ? 'Male' : p?.gender === 2 ? 'Female' : 'Other' }}
                    </td>

                    <td>{{p?.wardId?.name || 'NA'}}</td>

                    <td>{{p?.categoryId?.name}}</td>

                    <td>{{p?.createdAt | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

       
      <!-- Discharge Wise Count -->
      <div class="row mt-4">
        <div class="col-md-6">
          <h5 class="mb-4">Discharge Wise</h5>
          <app-card class='cursor'  cardTitle="Discharge Wise Count" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Discharge Type</th>
                    <th>Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let item of dashboardData?.dischargeWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPerson}}</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span  class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>

        <div class="col-md-6">
          <h5 class="mb-4">Recent Discharged People</h5>
          <app-card cardTitle="Recent Discharged People" cardClass="table-card" blockClass="p-0" class='cursor' >
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>Discharge Time</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let p of dashboardData?.dischargePeople; let i=index" [routerLink]="['/members']"  class='cursor'>
                    <td>{{i+1}}</td>
                    <td>{{p?.name}}</td>
                    <td>#{{p?.regNo}}</td>
                    <td>{{p?.closeTime | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

       <!-- if end -->

    </app-card>
  </div>
</div>



<!-- WARD INCHARGE -->
 <div class="row" *ngIf="userType==2">
  <div class="col-xl-12">
    <app-card cardTitle="Dashboard Overview" [options]="false" blockClass="table-border-style">

      <!-- Admin Dashboard (userType == 1) -->
      <div class="row">
        <!-- Home Count -->
        

        <!-- Hospital Count -->
        <div class="col-md-6 col-xl-4" *ngIf="false">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Hospital</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.hospitalCount}}
            </h3>
          </app-card>
        </div>

        <!-- Total Categories -->
        <div class="col-md-6 col-xl-4" *ngIf="false">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/categories')">
            <h6 class="mb-2">Total Categories</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-layers f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalCategories}}
            </h3>
          </app-card>
        </div>

        <!-- Total Wards -->
        <div class="col-md-6 col-xl-4" *ngIf="false">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/wards')">
            <h6 class="mb-2">Total Wards</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-grid f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWards}}
            </h3>
          </app-card>
        </div>

        <!-- Total Ward Incharge -->
        <div class="col-md-6 col-xl-4" *ngIf="false">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/users')">
            <h6 class="mb-2">Total Ward Incharge</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-user-check f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWardIncharge}}
            </h3>
          </app-card>
        </div>

        <!-- Total Discharged -->
        <div class="col-md-6 col-xl-4" *ngIf="false">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']" [queryParams]="{isShowDischage: true}">
            <h6 class="mb-2">Total Discharged</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-log-out f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalDischarge}}
            </h3>
          </app-card>
        </div>
      </div>


       <!-- Category Wise Table -->
      <div class="row mt-4">
        <!-- Ward Wise Count -->
        <div class="col-md-12">
          <h5 class="mb-4">Ward Wise</h5>
          <app-card cardTitle="Ward Wise Count" cardClass="table-card" blockClass="p-0" style="height:300px; overflow-y: auto;">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Ward</th>
                    <th>Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of dashboardData?.wardWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPersons}}</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>


      <!-- Ward Category Wise -->
      <div class="row mt-4" *ngIf="dashboardData?.wardCategoryWise && dashboardData?.wardCategoryWise?.length > 0">
        <div class="col-md-12">
          <app-card cardTitle="Ward Category Breakdown" [options]="false" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Ward</th>
                    <th>Category</th>
                    <th>Persons</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let ward of dashboardData?.wardCategoryWise">
                    <tr *ngFor="let cat of ward.categories; let isFirst = first">
                      <td *ngIf="isFirst" [attr.rowspan]="ward.categories.length">
                        {{ ward.wardName || 'Unassigned' }}
                      </td>
                      <td>{{ cat.categoryName }}</td>
                      <td>{{ cat.totalPersons }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

      <!-- Recent People -->
      <div class="row mt-4">
        <div class="col-md-12">
          <h5 class="mb-4">Recent Added People</h5>
          <app-card cardTitle="Recent People" cardClass="table-card" blockClass="p-0" class='cursor' >
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>Gender</th>
                    <th>Ward</th>
                    <th>Category</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let p of dashboardData?.recentPeople; let i=index" [routerLink]="['/member/view', p?._id]"  class='cursor'>
                    <td>{{i+1}}</td>

                    <td>{{p?.name}}</td>

                    <td>#{{p?.regNo}}</td>

                    <td>
                      {{ p?.gender === 1 ? 'Male' : p?.gender === 2 ? 'Female' : 'Other' }}
                    </td>

                    <td>{{p?.wardId?.name || 'NA'}}</td>

                    <td>{{p?.categoryId?.name}}</td>

                    <td>{{p?.createdAt | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

       
      <!-- Discharge Wise Count -->
      <div class="row mt-4">
        <div class="col-md-6">
          <h5 class="mb-4">Discharge Wise</h5>
          <app-card class='cursor'  cardTitle="Discharge Wise Count" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Discharge Type</th>
                    <th>Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let item of dashboardData?.dischargeWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPerson}}</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span  class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>

        <div class="col-md-6">
          <h5 class="mb-4">Recent Discharged People</h5>
          <app-card cardTitle="Recent Discharged People" cardClass="table-card" blockClass="p-0" class='cursor' >
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>Discharge Time</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let p of dashboardData?.dischargePeople; let i=index" [routerLink]="['/members']"  class='cursor'>
                    <td>{{i+1}}</td>
                    <td>{{p?.name}}</td>
                    <td>#{{p?.regNo}}</td>
                    <td>{{p?.closeTime | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

       <!-- if end -->

    </app-card>
  </div>
</div>



<!-- LAB TECHNICIAN -->
 <div class="row" *ngIf="userType==6">
  <div class="col-xl-12">
    <app-card cardTitle="Dashboard Overview" [options]="false" blockClass="table-border-style">

      <!-- Admin Dashboard (userType == 1) -->
      <div class="row">
        <!-- Home Count -->
       
        
         <!-- Hospital Count -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Pending Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.pending}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Completed Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.completed}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Rejected Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.rejected}}
            </h3>
          </app-card>
        </div>



        <!-- Hospital Count -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Pending Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.total?.pending}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Completed Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.total?.completed}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Rejected Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.total?.rejected}}
            </h3>
          </app-card>
        </div>

      
      </div>
    </app-card>
  </div>
</div>


<!-- DOCTOR -->
<div class="row" *ngIf="userType==3">
  <div class="col-xl-12">
    <app-card cardTitle="Dashboard Overview" [options]="false" blockClass="table-border-style">

      <!-- Admin Dashboard (userType == 1) -->
      <div class="row">
        <!-- Total Members Exist -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor' [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Members Exist</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-users f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalMembersExist ?? ((dashboardData?.totalHome ?? dashboardData?.homeCount ?? 0) + (dashboardData?.totalHospital ?? dashboardData?.hospitalCount ?? 0) + (dashboardData?.totalTemporary ?? dashboardData?.tempCount ?? 0))}}
            </h3>
          </app-card>
        </div>

        <!-- Home Count -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor' [hidHeader]="true" [routerLink]="['/members']" [queryParams]="{type: 'Home'}">
            <h6 class="mb-2">Total Home</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-home f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalHome ?? dashboardData?.homeCount}}
            </h3>
          </app-card>
        </div>

        <!-- Hospital Count -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']" [queryParams]="{type: 'Hospital'}">
            <h6 class="mb-2">Total Hospital</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalHospital ?? dashboardData?.hospitalCount}}
            </h3>
          </app-card>
        </div>

        <!-- Temporary Count -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']" [queryParams]="{type: 'Temporary'}">
            <h6 class="mb-2">Total Temporary</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-clock f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalTemporary ?? dashboardData?.tempCount}}
            </h3>
          </app-card>
        </div>

        <!-- Total Categories -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/categories')">
            <h6 class="mb-2">Total Categories</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-layers f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalCategories}}
            </h3>
          </app-card>
        </div>

        <!-- Total Wards -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/wards')">
            <h6 class="mb-2">Total Wards</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-grid f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWards}}
            </h3>
          </app-card>
        </div>

        <!-- Total Ward Incharge -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/users')">
            <h6 class="mb-2">Total Ward Incharge</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-user-check f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWardIncharge}}
            </h3>
          </app-card>
        </div>

        <!-- Total Discharged -->
        <div class="col-md-6 col-lg-3 col-xl-3">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']" [queryParams]="{isShowDischage: true}">
            <h6 class="mb-2">Total Discharged</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-log-out f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalDischarge}}
            </h3>
          </app-card>
        </div>

        <h3>Lab Test</h3>
        <hr>

        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Pending Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.pending}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Completed Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.completed}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Rejected Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.rejected}}
            </h3>
          </app-card>
        </div>



        <!-- Hospital Count -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Pending Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.total?.pending}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Completed Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.total?.completed}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Rejected Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.total?.rejected}}
            </h3>
          </app-card>
        </div>

        
      </div>

      <!-- Category Wise Table -->
      <div class="row mt-4">
        <div class="col-md-6">
          <h5 class="mb-4">Category Wise</h5>
          <app-card class='cursor'  cardTitle="Category Wise Count" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Category</th>
                    <th> Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let item of dashboardData?.categoriesWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPersons}}</td>
                    <td>

                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span  class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>

        <!-- Ward Wise Count -->
        <div class="col-md-6">
          <h5 class="mb-4">Ward Wise</h5>
          <app-card cardTitle="Ward Wise Count" cardClass="table-card" blockClass="p-0" style="height:300px; overflow-y: auto;">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Ward</th>
                    <th>Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of dashboardData?.wardWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPersons}}</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

      <!-- Ward Category Wise -->
      <div class="row mt-4" *ngIf="dashboardData?.wardCategoryWise && dashboardData?.wardCategoryWise?.length > 0">
        <div class="col-md-12">
          <h5 class="mb-4">Ward Category Breakdown</h5>
          <div class="row">
            <div class="col-md-4 mb-3" *ngFor="let ward of dashboardData?.wardCategoryWise">
              <app-card [cardTitle]="ward?.wardName">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let cat of ward.categories">
                    {{cat.categoryName}}
                    <span class="badge bg-primary rounded-pill">{{cat.totalPersons}}</span>
                  </li>
                </ul>
              </app-card>
            </div>
          </div>
        </div>
      </div>

      <!-- Recent People -->
      <div class="row mt-4">
        <div class="col-md-12">
          <h5 class="mb-4">Recent Added People</h5>
          <app-card cardTitle="Recent People" cardClass="table-card" blockClass="p-0" class='cursor' >
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>Gender</th>
                    <th>Ward</th>
                    <th>Category</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let p of dashboardData?.recentPeople; let i=index" [routerLink]="['/member/view', p?._id]"  class='cursor'>
                    <td>{{i+1}}</td>

                    <td>{{p?.name}}</td>

                    <td>#{{p?.regNo}}</td>

                    <td>
                      {{ p?.gender === 1 ? 'Male' : p?.gender === 2 ? 'Female' : 'Other' }}
                    </td>

                    <td>{{p?.wardId?.name || 'NA'}}</td>

                    <td>{{p?.categoryId?.name}}</td>

                    <td>{{p?.createdAt | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

       
      <!-- Discharge Wise Count -->
      <div class="row mt-4">
        <div class="col-md-6">
          <h5 class="mb-4">Discharge Wise</h5>
          <app-card class='cursor'  cardTitle="Discharge Wise Count" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Discharge Type</th>
                    <th>Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let item of dashboardData?.dischargeWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPerson}}</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span  class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>

        <div class="col-md-6">
          <h5 class="mb-4">Recent Discharged People</h5>
          <app-card cardTitle="Recent Discharged People" cardClass="table-card" blockClass="p-0" class='cursor' >
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>Discharge Time</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let p of dashboardData?.dischargePeople; let i=index" [routerLink]="['/members']"  class='cursor'>
                    <td>{{i+1}}</td>
                    <td>{{p?.name}}</td>
                    <td>#{{p?.regNo}}</td>
                    <td>{{p?.closeTime | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

       <!-- if end -->

    </app-card>
  </div>
</div>


<!-- RECEPTIONIST -->

<div class="row" *ngIf="userType==9">
  <div class="col-xl-12">
    <app-card cardTitle="Dashboard Overview" [options]="false" blockClass="table-border-style">

      <!-- Admin Dashboard (userType == 1) -->
      <div class="row">
        <!-- Home Count -->
        

        <!-- Hospital Count -->
       

        <!-- Total Categories -->
        
        <!-- Total Wards -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/wards')">
            <h6 class="mb-2">Total Wards</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-grid f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWards}}
            </h3>
          </app-card>
        </div>

        <!-- Total Ward Incharge -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" (click)="conditionalRouting('/users')">
            <h6 class="mb-2">Total Ward Incharge</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-user-check f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalWardIncharge}}
            </h3>
          </app-card>
        </div>

        <!-- Total Discharged -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']" [queryParams]="{isShowDischage: true}">
            <h6 class="mb-2">Total Discharged</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-log-out f-30 m-r-10" style="color:#003E53;"></i>
              {{dashboardData?.totalDischarge}}
            </h3>
          </app-card>
        </div>

        <h3>Lab Test</h3>
        <hr>

        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Pending Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.pending}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Completed Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.completed}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Today Rejected Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.today?.rejected}}
            </h3>
          </app-card>
        </div>



        <!-- Hospital Count -->
        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Pending Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.total?.pending}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Completed Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.total?.completed}}
            </h3>
          </app-card>
        </div>


        <div class="col-md-6 col-xl-4">
          <app-card class='cursor'  [hidHeader]="true" [routerLink]="['/members']">
            <h6 class="mb-2">Total Rejected Case</h6>
            <h3 class="f-w-300 d-flex align-items-center m-b-0">
              <i class="feather icon-activity f-30 m-r-10" style="color:#003E53;"></i>
              {{medicalDashboardData?.total?.rejected}}
            </h3>
          </app-card>
        </div>

        
      </div>

      <!-- Category Wise Table -->
      <div class="row mt-4">
        <div class="col-md-6">
          <h5 class="mb-4">Category Wise</h5>
          <app-card class='cursor'  cardTitle="Category Wise Count" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Category</th>
                    <th> Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let item of dashboardData?.categoriesWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPersons}}</td>
                    <td>

                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span  class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>

        <!-- Ward Wise Count -->
        <div class="col-md-6">
          <h5 class="mb-4">Ward Wise</h5>
          <app-card cardTitle="Ward Wise Count" cardClass="table-card" blockClass="p-0" style="height:300px; overflow-y: auto;">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Ward</th>
                    <th>Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of dashboardData?.wardWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPersons}}</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

      <!-- Ward Category Wise -->
      <div class="row mt-4" *ngIf="dashboardData?.wardCategoryWise && dashboardData?.wardCategoryWise?.length > 0">
        <div class="col-md-12">
          <app-card cardTitle="Ward Category Breakdown" [options]="false" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Ward</th>
                    <th>Category</th>
                    <th>Persons</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let ward of dashboardData?.wardCategoryWise">
                    <tr *ngFor="let cat of ward.categories; let isFirst = first">
                      <td *ngIf="isFirst" [attr.rowspan]="ward.categories.length">
                        {{ ward.wardName || 'Unassigned' }}
                      </td>
                      <td>{{ cat.categoryName }}</td>
                      <td>{{ cat.totalPersons }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

      <!-- Recent People -->
      <div class="row mt-4">
        <div class="col-md-12">
          <h5 class="mb-4">Recent Added People</h5>
          <app-card cardTitle="Recent People" cardClass="table-card" blockClass="p-0" class='cursor' >
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>Gender</th>
                    <th>Ward</th>
                    <th>Category</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let p of dashboardData?.recentPeople; let i=index" [routerLink]="['/member/view', p?._id]"  class='cursor'>
                    <td>{{i+1}}</td>

                    <td>{{p?.name}}</td>

                    <td>#{{p?.regNo}}</td>

                    <td>
                      {{ p?.gender === 1 ? 'Male' : p?.gender === 2 ? 'Female' : 'Other' }}
                    </td>

                    <td>{{p?.wardId?.name || 'NA'}}</td>

                    <td>{{p?.categoryId?.name}}</td>

                    <td>{{p?.createdAt | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

       
      <!-- Discharge Wise Count -->
      <div class="row mt-4">
        <div class="col-md-6">
          <h5 class="mb-4">Discharge Wise</h5>
          <app-card class='cursor'  cardTitle="Discharge Wise Count" cardClass="table-card" blockClass="p-0">
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>Discharge Type</th>
                    <th>Persons</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let item of dashboardData?.dischargeWise; let i=index">
                    <td>{{item?.name}}</td>
                    <td>{{item?.totalPerson}}</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <ng-container *ngIf="item.flow==='up'">
                          <mat-icon style="color:red">trending_up</mat-icon>
                        </ng-container>
                         <ng-container *ngIf="item.flow==='down'">
                          <mat-icon style="color:green">trending_down</mat-icon>
                        </ng-container>
                        <span  class="mx-2">{{item?.percentage}}%</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>

        <div class="col-md-6">
          <h5 class="mb-4">Recent Discharged People</h5>
          <app-card cardTitle="Recent Discharged People" cardClass="table-card" blockClass="p-0" class='cursor' >
            <div class="table-responsive table-wrapper">
              <table class="table table-bordered sticky-table">
                <thead class="t_head">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>Discharge Time</th>
                  </tr>
                </thead>
                <tbody style="height:300px; overflow-y: auto;">
                  <tr *ngFor="let p of dashboardData?.dischargePeople; let i=index" [routerLink]="['/members']"  class='cursor'>
                    <td>{{i+1}}</td>
                    <td>{{p?.name}}</td>
                    <td>#{{p?.regNo}}</td>
                    <td>{{p?.closeTime | date:'medium'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </app-card>
        </div>
      </div>

       <!-- if end -->

    </app-card>
  </div>
</div>






